import { Box } from "@mui/material"
import { ReactElement, useState } from "react"

import Evcp1 from "../../assets/images/evcp1.png"
import Evcp2 from "../../assets/images/evcp2.png"
import Evcp3 from "../../assets/images/evcp3.png"
import Hp1 from "../../assets/images/hp1.png"
import SolarPanel1 from "../../assets/images/solarPanel1.png"
/**
 * Randomly image select function
 * @returns
 */
const getRandomImage = (images: string[]): string =>
    images[Math.floor(Math.random() * images.length)]

interface ILctHoneyCombMaskProps {
    maxWidth: string
}

/** Random lCT image with honeycomb mask */
const LctHoneyCombMask = ({
    maxWidth,
}: ILctHoneyCombMaskProps): ReactElement => {
    const images = [Hp1, Evcp1, Evcp2, Evcp3, SolarPanel1]
    const [randomImage] = useState(() => getRandomImage(images))
    return (
        <Box
            maxWidth={maxWidth}
            sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                backgroundImage: `url(${randomImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                maskImage: "url(publicAssets/honeycombMask.svg)",
                WebkitMaskImage: "url(publicAssets/honeycombMask.svg)",
                maskSize: "100%",
                WebkitMaskSize: "100%",
                maskRepeat: "no-repeat",
                WebkitMaskRepeat: "no-repeat",
            }}
        />
    )
}

export default LctHoneyCombMask
